import React from "react";
import "./WhiteLogo.css";

const BlackLogo = () => {
  return (
    <div className="white-menu-logo">
      <img
        src="/assets/img/blacklogo.png"
        alt="whitelogo"
        className="img-fluid"
      />
    </div>
  );
};

export default BlackLogo;
